//NAR OPERATOR
const en_NAR = {
  yes: 'Yes',
  no: 'No',
  no_thanks: 'No, thank you',
  loading: 'Loading...',
  global_error: 'Sorry, site is unavailable due technicals reason. Please, try again later',
  email: 'Phone',
  password: 'Password',
  close: 'Close',
  favorites: 'Favorites',
  search: 'Search',
  related: 'Related',
  tv: 'TV Channels',
  movies: 'Movies',
  tvseries: 'TV Series',
  on_now: 'Guide',
  cartoons: 'Cartoons',
  purchases: 'Purchases',
  premiere: 'Premieres',
  my_services: {
    my_services: 'My services',
    my_rents: 'My content',
    my_subscriptions: 'My subscriptions',
    subscriptions: 'Subscribe',
    rents: 'Rent'
  },
  page: {
    home: 'Home',
    epg: 'Guide',
    favorites: 'Favorites',
    notifications: 'Notifications',
    records: 'My records',
    purchases: 'Purchases',
    related: 'Related',
    search: 'Search',
    collection: 'Collection'
  },
  error: {
    invalid_credentials: 'Login or password is wrong',
    invalid_credentials_description: ' ',
    blocked_subscription: 'Currently your subscription is not active. Please top up your balance to activate services.',
    'invalid credentials': 'Incorrect current password',
    'passwords mismatch': 'The passwords don\'t match.',
    'username field empty': 'Please add your phone address.',
    'invalid subscriber nar msisdn': 'This phone number does not exist',
    'already registered': 'This user is already registered. Please Sign In or choose another phone to sign up',
    'password field empty': 'Please insert your password.',
    'code field empty': 'Please insert code from SMS',
    'password too short': 'The password must be at least 6 characters. You can use letters, numbers, and any special characters.',
    'invalid password reset code': 'Invalid confirmation code',
    'invalid ack': 'Invalid confirmation code',
    'invalid pin': 'Invalid PIN-code',
    'invalid registration code': 'Invalid code from SMS',
  },
  registration: {
    texts: {
      button: 'Create account',
      title: 'Register now',
      description: 'For using the services, please get registered.'
    }
  },
  login: {
    login: 'Phone',
    login_example: '+994xxxxxxxxx',
    lost_your_password: 'Forgot password?',
    logout: 'Log out',
    log_in: 'Log in'
  },
  forgot_password: {
    login: 'Phone',
    login_example: '+994xxxxxxxxx',
    lost_your_password: 'Lost your password?',
    forgot_password: 'Forgot password?',
    send: "Send",
    recovery_password: "Recover password",
    empty_field: "Empty field",
    wrong_email: "Wrong Phone Number",
    reset_password_success_message: "You will receive an email with a link to reset your password.",
    reset_password_error_message: "You will receive an email with a link to reset your password.",
  },
  profile: {
    movie: {
      bundle: 'Subscription',
      min: 'min',
      fav_add: 'Add to favorites',
      fav_remove: 'Remove from favorites',
      trailer: 'Trailer',
      youtube_trailer: 'Youtube Trailer',
      multiscreen: 'Continue on another device',
      related: 'Related',
      share: 'Share',
      select_screen: 'Select screen'
    },
    tvSeries: {
      bundle: 'Subscription',
      min: 'min',
      fav_add: 'Add to favorites',
      fav_remove: 'Remove from favorites',
      trailer: 'Trailer',
      multiscreen: 'Continue on another screen',
      related: 'Related',
      share: 'Share',
      select_screen: 'Select screen',
      seasons: 'Seasons',
      episodes: 'Episodes',
      season_short: 'S', //S01E12
      episode_short: 'E', //S01E12
    },
    channel: {
      calendar: {
        before: 'Before',
        previously: 'Previously',
        now: 'Now',
        after: 'Next',
        hereafter: 'Later',
        yesterday: 'Yesterday',
        yesterday_at: 'Yesterday at',
        today: 'Today',
        today_at: 'Today at',
        tomorrow: 'Tomorrow',
        tomorrow_at: 'Tomorrow at',
        last: 'Duration'
      },
      epg: 'TV guide',
      bundle: 'Subscrition',
      min: 'min',
      fav_add: 'Add to favorites',
      fav_remove: 'Remove from favorites',
      record_add: 'Add to record',
      record_remove: 'Delete from record',
      schedule_remove: 'Cancel record',
      multiscreen: 'Continue on another device',
      share: 'Share',
      select_screen: 'Select screen'
    },
    subscription: {
      subscription: 'Subscriptions',
      included: 'Included',
      expires: 'Expires',
      bought: 'Bought',
      owned: 'Owned',
      subscription_period_end: 'Next payment date',
      subscription_period_start: 'Subscription start date',
      subscription_states: {
        active: 'Active',
        trialing: 'Trial',
        unpaid: 'Inactive',
        '_': 'Unknown'
      },
      cancel: 'Cancel subscription',
      canceled: 'Canceled',
      first_payment: 'First payment',
      details: 'Details',
      status: 'Status',
      are_you_sure: 'Are you sure',
      cancel_desc: 'You want to cancel your subscription for',
      re_subscribe: 'You can re-activate your subscription only after the end of the current period.',
      yes: 'Yes',
      no: 'No'
    },
    packages: {
      included: 'Included',
      expires: 'Expires',
      bought: 'Bought',
      owned: 'Owned'
    },
    epg_event: {
      remind_me: 'Remind me',
      not_remind: 'Not to remind',
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record'
    },
    notification: {
      remind_me: 'Remind me',
      not_remind: 'Not to remind',
    },
    npvr: {
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Operator',
      assembly: 'Assembly',
      actor: 'Actor',
      director: 'Director',
      scenario: 'Scenario',
      composer: 'Composer',
      presenter: 'Presenter',
      music_director: 'Music Director',
      playback_singers: 'Playback Singers',
      _: 'other'
    },
    offers: {
      type: {
        'free': 'Free',
        'transactional-own': 'Buy',
        'transactional-rent': 'Rent',
        'subscription': 'Subscribe',
        'transactional-own-bundle': 'Buy in bundle',
        'transactional-rent-bundle': 'Rent in bundle',
        'subscription-bundle': 'Subscribe in bundle',
        '_': 'Other'
      },
      pay_as_you_go: 'Purchase offers',
      select_bundle: 'Select bundle',
      or: 'or',
      free_trial: 'free trial',
      free_trial_description: 'On expiery of trial period, subscription fee will be deducted from your balance.',
      unit: {
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
      }
    }
  },
  player: {
    no_signal: 'No signal',
    youtube_connection_error: 'Youtube connection error'
  },
  more_menu_items: 'More',
  empty_section: 'Current section is empty',
  empty_result: 'No result',
  epg: {
    no_data: 'No data',
    now: 'Now',
    today: 'Today'
  },
  npvr: {
    filters: {
      status: 'Sort by recording state',
      date: 'Sort by recording date',
      alphabet: 'Sort by recording title',
      channel: 'Sort by recording channel'
    },
    status: {
      pending: 'Pending',
      scheduled: 'In schedule',
      recording: 'In progress',
      finished: 'Finished',
      failed: 'Failed',
      cancelled: 'Canceled'
    }
  },
  genres: 'Genres',
  messages: {
    pin: {
      title: 'Enter your PIN code',
      ok: 'Ok',
      cancel: 'Cancel'
    },
    notification: {
      title: 'Reminder on ',
      on_channel: 'On channel',
      is_switch_show_right_now: 'starts in 5 minutes. Switch to show right now?'
    },
    share_request: {
      title: 'Share ',
      vod: 'video',
      live: 'channel',
      you_have_received: 'You have received',
      sharing_notification: 'sharing notification. Do you want to watch?'
    },
    bookmark: {
      title: 'Continue to watch?',
      continue_from: 'Continue from',
      start_over: 'Start over'
    }
  },
  settings: {
    settings: 'Settings',
    tabs: {
      login: {
        title: 'Login',
        email: 'Phone',
        password: 'Password',
        sign_in: 'Sign in',
        error: 'Login or password is incorrect.',
        success: 'Welcome!'
      },
      registration: {
        title: 'Registration',
        email: 'Phone',
        password: 'Password',
        password2: 'Confirm password',
        first_name: 'Name',
        last_name: 'Last name',
        sign_up: 'Sign up',
        code: 'Code',
        success: "Thanks you for your registration!",
        need_confirmation: "Please confirm your registration by clicking to a link that was sent to your email address.",
      },
      registration_confirm: {
        success: "Thank you for registration. Your login and password can now be used on other devices where this service is available."
      },
      language: {
        title: 'Language',
        select_language: 'Select language:'
      },
      parental_control: {
        title: 'Parental control',
        description: 'Enable parental control',
        on: 'On',
        off: 'Off'
      },
      change_password: {
        title: 'Change password',
        save: 'Save',
        old_password: 'Current Password',
        new_password: 'Please enter a new password',
        new_password2: 'Confirm password',
        success: 'Password is updated successfully'
      },
      reset_password: {
        title: 'Reset password',
        save: 'Save',
        enter_new_password: 'Еnter a new password',
        ack: 'Confirmation Code',
        password: 'New Password',
        success: 'Password is updated successfully'
      },
    },
  },
  toast: {
    type: {
      record: 'Record',
      favorite: 'Favorite',
      notification: 'Notification',
      purchase: 'Purchase',
      service: 'Services',
      cookies: 'Cookies',
      adblock: 'Ad Block'
    },
    operation: {
      record_add_success: 'The recording was successfully scheduled',
      record_add_fail: 'The recording was failed to schedule.',
      record_remove_success: 'The cancellation of recording was successful.',
      record_remove_fail: 'The cancellation of recording was failed.',
      favorite_add_success: 'Successfully added.',
      favorite_add_fail: 'Failed to add',
      favorite_remove_success: 'Successfully removed.',
      favorite_remove_fail: 'Failed to remove',
      notification_add_success: 'Successfully added.',
      notification_add_fail: 'Failed to add',
      notification_remove_success: 'Successfully removed.',
      notification_remove_fail: 'Failed to remove',
      purchase_add_success: 'Operation was successfully completed',
      purchase_add_fail: 'Operation failed',
      purchase_remove_success: 'Operation was successfully completed',
      purchase_remove_fail: 'Operation is failed',
      service_unstable_connection: 'Unstable connection to server',
      enable_cookies: 'Please enable cookies. ',
      disable_adblock: 'AdBlock can affect the functionality of the site. ' +
      'Please add us to Whitelist in your Ad blocker.',
    }
  }
};

export default en_NAR;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/nar/en_NAR.js